<template>
  <g>
    <text
      v-for="l in lines"
      fill="white"
      :key="l.text"
      :x="l.x"
      :y="l.y"
      :class="l.class"
      text-anchor="middle"
      >{{ l.text }}</text
    >
  </g>
</template>
<script>
import {
  filterIllegalCharacters,
  filterTooLongLines,
  filterTooManyLines,
} from '../../util/filterInput.js'

const lineHeight = 20

export default {
  name: 'PosterTextBox',
  props: {
    headerText: {
      type: String,
      required: true,
    },
    headerCssClass: {
      type: String,
      required: true,
    },
    dedicationText: {
      type: String,
      required: true,
    },
    dedicationCssClass: {
      type: String,
      required: true,
    },
    xCenter: {
      type: Number,
      required: true,
    },
    yCenter: {
      type: Number,
      required: true,
    },
  },
  computed: {
    lines: function() {
      const headerText = filterIllegalCharacters(
        filterTooLongLines(filterTooManyLines(this.headerText, 1), 40)
      )
      const dedicationLines = filterIllegalCharacters(
        filterTooLongLines(filterTooManyLines(this.dedicationText))
      ).split('\n')
      // if you have an empty dedication, you will still have one dedication line, for centering we ignore it here
      const dedicationLinesCount =
        dedicationLines.length == 1 && dedicationLines[0] == ''
          ? 0
          : dedicationLines.length
      const headerLinePosition =
        this.yCenter - (dedicationLinesCount / 2) * lineHeight
      let dedicationLineStart = headerLinePosition
      const lines = []
      if (headerText != '') {
        lines.push({
          text: headerText,
          x: this.xCenter,
          y: headerLinePosition,
          class: this.headerCssClass,
        })
        dedicationLineStart += lineHeight * 1.2
      }

      return lines.concat(
        dedicationLines.map((line, index) => {
          return {
            text: line,
            x: this.xCenter,
            y: dedicationLineStart + lineHeight * index,
            class: this.dedicationCssClass,
          }
        })
      )
    },
  },
}
</script>
